export const displayModes = {
  carrier: 'carrier',
  admin: 'admin',
  shipper: 'shipper',
  shared: 'shared'
};
